
























import {Component, Vue} from 'vue-property-decorator';
import {SelectWings} from "wings-ui-components";
import {Action, Getter} from 'vuex-class';
import draggable from 'vuedraggable'
import RegexItem from "@/components/Settings/MessageCategories/RegexItem.vue";
import {ServiceProviderItem} from "@/store/settings/service_providers/types";

@Component({components: {RegexItem, SelectWings, draggable}})
export default class Regexes extends Vue {

  @Action("getServiceProviders") actionGetServiceProviders: any;
  @Action("getAllowedTransports") actionAllowedTransports: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getMessageCategories") actionMessageCategories: any;

  @Getter('serviceProviders') serviceProvidersList!: ServiceProviderItem[];
  @Getter("allowedTransports") allowedTransportsList: any;
  @Getter("transports") transportsList: any;

  created() {
    this.actionGetServiceProviders();
    this.actionAllowedTransports();
    this.actionGetTransports();
    this.actionMessageCategories();
  }

  // проверяем существует ли транспорт у поставщика услуг с allowedTransports
  checkAllowedTransport(item: any) {
    let allowedTransports = this.getTransportName(this.allowedTransportsList);
    let allow:boolean = allowedTransports.some((e:any) => item.transport_names.includes(e));
    return allow
  }

  // в методе getTransportName из allowedTransportsList получаем массив с именами транспортов
  getTransportName(allowedTransports: any): any {
    let transports: any = [];
    allowedTransports.forEach((transport_id: any) => {
      transports.push(this.transportsList.find((t: any) => t.id === transport_id)?.name);
    })
    return transports;
  }

  back(): void {
    this.$router.push('/settings/message_categories/');
  }
};
